/**
 * @generated SignedSource<<51b90a6ba42a83ae43d15d27eb13b452>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignsDirectory_iconicDesignsDirectoryPage$data = {
  readonly directory: ReadonlyArray<{
    readonly designs: ReadonlyArray<{
      readonly creators: string | null;
      readonly name: string | null;
      readonly urlLabel: string | null;
    } | null> | null;
    readonly label: string | null;
  }>;
  readonly " $fragmentType": "DesignsDirectory_iconicDesignsDirectoryPage";
};
export type DesignsDirectory_iconicDesignsDirectoryPage$key = {
  readonly " $data"?: DesignsDirectory_iconicDesignsDirectoryPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignsDirectory_iconicDesignsDirectoryPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignsDirectory_iconicDesignsDirectoryPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesignsDirectoryListObject",
      "kind": "LinkedField",
      "name": "directory",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IconicDesignsDirectoryListDesigns",
          "kind": "LinkedField",
          "name": "designs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "creators",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IconicDesignsDirectoryPage",
  "abstractKey": null
};

(node as any).hash = "a729d84bf89c025820fc337f94f0ff71";

export default node;
